import { render } from "./NoticeMaster.vue?vue&type=template&id=67a5f17b&scoped=true"
import script from "./NoticeMaster.vue?vue&type=script&lang=js"
export * from "./NoticeMaster.vue?vue&type=script&lang=js"

import "./NoticeMaster.vue?vue&type=style&index=0&id=67a5f17b&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5f17b"]])

export default __exports__